<template>
  <div>
    <form class="profile-form">
      <!-- {{ timezones }} -->
      <div class="mb-2" :class="{ invalid: $v.title.$error }">
        <label>Title*</label>
        <input type="text" class="form-control" v-model="title">
        <small v-if="$v.title.$error">Title is required.</small>
      </div>

      <div class="row">
        <div class="col-lg-9">
          <label>Description</label>
          <div class="editor">
            <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
            <editor-menu-bar :editor="descriptionEditor" v-slot="{ commands, isActive }" class="mb-1">
              <div class="menubar">
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                  <strong>B</strong>
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                  <i>Italics</i>
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                  <u>U</u>
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                  Image
                </button> -->
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
                  Image
                </button> -->
                <!-- https://github.com/scrumpy/tiptap/issues/89 -->
                <!-- https://codesandbox.io/s/j3p0z44155 -->
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
                  Image
                </button> -->
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                  H1
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                  H2
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                  H3
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                  List
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                  1. 2. 3...
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                  ""
                </button> -->
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                  ---
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                  Undo
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                  Redo
                </button> -->
              </div>
            </editor-menu-bar>
            <editor-content class="editor__content" :editor="descriptionEditor" />
          </div>
        </div>
        <div class="col-lg-3">
          <!-- <label>Key Skills</label>
          <div class="form-check" v-for="(skill, index) in skillsOptions" :key="'SelectSkills'+index">
            <input class="form-check-input" type="checkbox" :value="skill" v-model="skills">
            <label class="form-check-label">
              {{ skill }}
            </label>
          </div> -->
          <label>Topic Areas</label>
          <multiselect v-model="focusAreas" :options="focusAreasOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Select Areas"></multiselect>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-6">
              <label>Type*</label>
              <select class="form-control" v-model="type">
                <option v-for="(eventType, index) in typeOptions" :key="'SelectType'+index">{{ eventType }}</option>
              </select>
            </div>
            <div class="col-lg-6">
              <label>Event Fee?</label>
              <select class="form-control" v-model="isFee">
                <!-- <option v-for="(compensationType, index) in compensationTypeOptions" :key="'SelectCompType'+index">{{ compensationType }}</option> -->
                <option>Yes</option>
                <option>No</option>
              </select>
              <div v-if="isFee == 'Yes'">
                <label>Event Fee</label>
                <input type="text" class="form-control" v-model="fee">
              </div>
            </div>
          </div>
          <!-- <label>Event Link</label> -->
          <label>Registration Information (registration link or email to sign up)</label>
          <input type="text" class="form-control" v-model="link">
        </div>

        <div class="col-lg-6">
          <label>Event Date*</label>
          <datepicker class="form-control" placeholder="" v-model="date" :disabled-dates="disabledDates" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
          <div class="form-check">
            <input class="form-check-input" style="margin-top: 6px;" type="checkbox" :value="true" v-model="multiday">
            <label class="form-check-label">
              This is a multi-day event
            </label>
          </div>
          <div v-if="multiday">
            <label>End Date*</label>
            <datepicker class="form-control" placeholder="" v-model="endDate" :disabled-dates="disabledDates" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <label>Start Time</label>
              <div class="input-group">
                <select class="form-control" v-model="startHour">
                  <option>HH</option>
                  <option v-for="(hour, index) in hourOptions" :key="'StartHour'+index">{{ hour }}</option>
                </select>
                <select class="form-control" v-model="startMinute">
                  <option>MM</option>
                  <option v-for="(minute, index) in minuteOptions" :key="'StartMinute'+index">{{ minute }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <label>End Time</label>
              <div class="input-group">
                <select class="form-control" v-model="endHour">
                  <option>HH</option>
                  <option v-for="(hour, index) in hourOptions" :key="'EndHour'+index">{{ hour }}</option>
                </select>
                <select class="form-control" v-model="endMinute">
                  <option>MM</option>
                  <option v-for="(minute, index) in minuteOptions" :key="'EndMinute'+index">{{ minute }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <label>Time Zone</label>
              <select class="form-control" v-model="timezone">
                <option v-for="(timezone, index) in timezones" :key="'TimeZone'+index">{{ timezone }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" :value="true" v-model="virtual">
        <label class="form-check-label">
          This is a virtual event (no physical location)
        </label>
      </div>
      <div class="row pb-3" v-if="!virtual">
        <div class="col-lg-6">
          <label>Address Line 1</label>
          <input type="text" class="form-control" v-model="address1">
          <label>Address Line 2</label>
          <input type="text" class="form-control" v-model="address2">
          <label>Postal/Zip Code</label>
          <input type="text" class="form-control" v-model="postalCode">
        </div>
        <div class="col-lg-6">
          <label>City</label>
          <input type="text" class="form-control" v-model="city">
          <label>Province/State</label>
          <input type="text" class="form-control" v-model="provinceState">
          <label>Country</label>
          <!-- <input type="text" class="form-control" placeholder="" v-model="country"> -->
          <select class="form-control" v-model="country">
            <option v-for="(country, index) in countries" :key="'countrySelection'+index">{{ country }}</option>
          </select>
        </div>
      </div>

      <!-- <button class="btn btn-primary mt-3" style="display: block;" @click.prevent="save()">Post</button> -->
      <!-- {{ user }} -->
      <button v-if="!listingID" class="mylisting-button dark-button mt-3" style="display: block;" @click.prevent="post()">Post</button>
      <button v-if="listingID" class="mylisting-button dark-button mt-3" style="display: block;" @click.prevent="update()">Save</button>
      <!-- {{ userID }} -->
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
  import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

  // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
  // Import the editor
  import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
  // import Icon from 'Components/Icon'
  import {
    Blockquote,
    CodeBlock,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
  } from 'tiptap-extensions'

  import timezones from 'compact-timezone-list';

  export default {
    // props: ['userID'],
    props: ['userID', 'listingID'],
    components: {
      EditorContent,
      EditorMenuBar,
      Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
    },
    data() {
      return {
        user: {},

        title: '',
        description: '',
        descriptionEditor: null,
        focusAreas: [],
        focusAreasOptions: [],
        type: '',
        typeOptions: [],
        virtual: false,
        fee: '',
        isFee: 'No',
        compensationTypeOptions: [],
        date: null,
        // disabledDates: {
        //   to: new Date(),
        // },
        multiday: false,
        endDate: null,
        startHour: 'HH',
        startMinute: 'MM',
        startTime: null,
        endHour: 'HH',
        endMinute: 'MM',
        endTime: null,
        link: '',

        city: '',
        provinceState: '',
        country: '',
        countries: [],
        address1: '',
        address2: '',
        postalCode: '',

        // jobID: null,
        listingToEdit: {},

        hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
        minuteOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
                        '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
                        '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],

        timezone: '',
        timezones: [],
      }
    },
    validations: {
      title: {
        required,
      }
    },
    created() {
      this.getUser()

      this.focusAreasOptions = this.$store.getters.focusAreas
      this.typeOptions = this.$store.getters.eventTypes
      this.compensationTypeOptions = this.$store.getters.compensationTypes
      this.countries = this.$store.getters.countries

      // this is for a unique route for editing a job /edit-job/id
      if (this.$route.params.id) {
        this.jobID = this.$route.params.id
      }

      this.timezones = timezones
      // https://stackoverflow.com/questions/19590865/from-an-array-of-objects-extract-value-of-a-property-as-array
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
      this.timezones = this.timezones.map(timezone => timezone.label)

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    mounted() {
      this.descriptionEditor = new Editor({
        // content: this.description,
//         content: '\
// <h4>Summary</h4><p></p><hr>\
// <h4>Roles and Responsibilities</h4><p></p><hr>\
// <h4>Required Qualifications</h4><p></p><hr>\
// <h4>Preferred Qualifications</h4><p></p><hr>\
// <h4>Additional Information</h4><p></p>',
        content: '',
        autoFocus: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3, 4, 5] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
        ],
        onUpdate: ({ getJSON, getHTML }) => {
          // this.json = getJSON()
          // this.html = getHTML()
          this.description = getHTML()
        },
      })
    },
    beforeDestroy() {
      this.descriptionEditor.destroy()
    },
    computed: {
      disabledDates() {
        // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
        // https://www.npmjs.com/package/vuejs-datepicker#usage
        let today = new Date()
        let disabledDates = {
          to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
        }
        return disabledDates
      },
    },
    methods: {
      getUser() {
        axios.get('/api/people/?id='.concat(this.userID))
          .then(res => {
            // console.log(res)
            this.user = res.data[0]

            this.address1 = this.user.address1
            this.address2 = this.user.address2
            this.postalCode = this.user.postal_code
            this.city = this.user.city
            this.provinceState = this.user.provincestate
            this.country = this.user.country

            // If jobID is not null, that means we are editing an existing job
            if (this.listingID) {
              console.log('Editing Job')
              console.log(this.listingID)
              axios.get('/api/events/?id='.concat(this.listingID.toString()))
                .then(res => {
                  console.log(res.data[0])
                  this.listingToEdit = res.data[0]

                  this.title = this.listingToEdit.title
                  this.descriptionEditor.setContent(this.listingToEdit.description)
                  this.description = this.listingToEdit.description
                  this.focusAreas = this.listingToEdit.categories
                  this.type = this.listingToEdit.event_type
                  // this.compensationType = this.jobToEdit.compensation_type
                  this.fee = this.listingToEdit.fee
                  if (this.fee) {
                    this.isFee = 'Yes'
                  }
                  // this.applicationDeadline = this.jobToEdit.application_deadline

                  if (this.listingToEdit.date) {
                    this.date = new Date(this.listingToEdit.date.concat('T00:00:00')) // The date was showing as one day previous, because it was being set as 00:00:00 UTC, and then subtracting 5 hours for ET, which made it one day early
                  }
                  if (this.listingToEdit.end_date) {
                    this.date = new Date(this.listingToEdit.end_date.concat('T00:00:00')) // The date was showing as one day previous, because it was being set as 00:00:00 UTC, and then subtracting 5 hours for ET, which made it one day early
                  }
                  if (this.listingToEdit.start_time) {
                    this.startHour = this.listingToEdit.start_time.split(':')[0]
                    this.startMinute = this.listingToEdit.start_time.split(':')[1]
                  }
                  if (this.listingToEdit.end_time) {
                    this.endHour = this.listingToEdit.end_time.split(':')[0]
                    this.endMinute = this.listingToEdit.end_time.split(':')[1]
                  }

                  this.timezone = this.listingToEdit.timezone

                  this.link = this.listingToEdit.link

                  this.address1 = this.listingToEdit.address1
                  this.address2 = this.listingToEdit.address2
                  this.postalCode = this.listingToEdit.postal_code
                  this.city = this.listingToEdit.city
                  this.provinceState = this.listingToEdit.provincestate
                  this.country = this.listingToEdit.country
                })
                .catch(error => console.log(error))
            }
          })
          .catch(error => console.log(error))
      },
      prepBeforeSaving() {
        console.log('Prepping before saving')

        console.log(this.userID)
        console.log(this.user.employer_name)
        console.log(this.title)
        console.log(this.description)
        console.log(this.skills)
        console.log(this.jobType)
        // console.log(this.compensationType)
        console.log(this.fee)
        console.log(this.date)
        console.log(this.startHour)
        console.log(this.startMinute)
        console.log(this.endHour)
        console.log(this.endMinute)
        console.log(this.link)
        console.log(this.address1)
        console.log(this.address2)
        console.log(this.postalCode)
        console.log(this.city)
        console.log(this.provinceState)
        console.log(this.country)

        // If the event is virtual we want to clear all the address fields
        // This way when we retrieve it later, we know a blank address means virtual
        if (this.virtual) {
          this.address1 = ''
          this.address2 = ''
          this.postalCode = ''
          this.city = ''
          this.provinceState = ''
          this.country = ''
        }

        // Need to get the time into the format hh:mm:ss
        if (this.startHour != 'HH') {
          this.startTime = this.startHour
          if (this.startMinute != 'MM') {
            this.startTime += (':' + this.startMinute + ':00')
          }
          else {
            this.startTime += (':00:00')
          }
        }
        if (this.endHour != 'HH') {
          this.endTime = this.endHour
          if (this.endMinute != 'MM') {
            this.endTime += (':' + this.endMinute + ':00')
          }
          else {
            this.endTime += (':00:00')
          }
        }

        // Need to get the date in the format YYYY-MM-DD
        if (this.date) {
          this.date =
            this.date.getFullYear().toString() +
            // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
            '-' + ('0' + (this.date.getMonth()+1).toString()).slice(-2) +
            '-' + ('0' + this.date.getDate().toString()).slice(-2)
        }
        if (this.endDate) {
          this.endDate =
            this.endDate.getFullYear().toString() +
            // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
            '-' + ('0' + (this.endDate.getMonth()+1).toString()).slice(-2) +
            '-' + ('0' + this.endDate.getDate().toString()).slice(-2)
        }
      },
      test() {
        console.log('skjlghfjdlakj')
      },
      post() {

        this.prepBeforeSaving()
        // // Need to strip the compensation down to only numbers?
        // // Will the application deadline work directly?

        // // If the event is virtual we want to clear all the address fields
        // // This way when we retrieve it later, we know a blank address means virtual
        // if (this.virtual) {
        //   this.address1 = ''
        //   this.address2 = ''
        //   this.postalCode = ''
        //   this.city = ''
        //   this.provinceState = ''
        //   this.country = ''
        // }

        // let startTime = null
        // let endTime = null
        // // Need to get the time into the format hh:mm:ss
        // if (this.startHour != 'HH') {
        //   startTime = this.startHour
        //   if (this.startMinute != 'MM') {
        //     startTime += (':' + this.startMinute + ':00')
        //   }
        //   else {
        //     startTime += (':00:00')
        //   }
        // }
        // if (this.endHour != 'HH') {
        //   endTime = this.endHour
        //   if (this.endMinute != 'MM') {
        //     endTime += (':' + this.endMinute + ':00')
        //   }
        //   else {
        //     endTime += (':00:00')
        //   }
        // }

        // let date = null
        // // Need to get the date in the format YYYY-MM-DD
        // if (this.date) {
        //   date =
        //   this.date.getFullYear().toString() +
        //   // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
        //   '-' + ('0' + (this.date.getMonth()+1).toString()).slice(-2) +
        //   '-' + ('0' + this.date.getDate().toString()).slice(-2)
        // }

        axios.post('/api/events/', {
          poster: this.userID,
          poster_name: this.user.employer_name,
          title: this.title,
          description: this.description,
          categories: this.focusAreas,
          event_type: this.type,
          // compensation_type: this.compensationType,
          fee: this.fee,
          // application_deadline: this.applicationDeadline,
          link: this.link,

          // date: date,
          date: this.date,
          end_date: this.endDate,
          // start_time: startTime,
          // end_time: endTime,
          start_time: this.startTime,
          end_time: this.endTime,
          timezone: this.timezone,

          address1: this.address1,
          address2: this.address2,
          postal_code: this.postalCode,
          city: this.city,
          provincestate: this.provinceState,
          country: this.country,

          // agency: 4,
          agency: this.$store.getters.agencyID,
          // agency_owner: 'ThriveHire',
          agency_owner: this.$store.getters.agencyName,
        })
          .then(res => {
            console.log('Event Posted')
            console.log(res)

            // broadcast to the parent compoenent that a job has been posted
            // this.$emit('jobPosted', true) // Lecture 112
            this.$emit('eventPosted') // Lecture 112

            // Email to inform Hayley and I of new job posts
            this.$store.dispatch('sendEmail',
              {
                subject: 'New Event Post!',
                message: 'New event posted with the title: '+this.title+'\nOrganization: '+this.user.employer_name,
                // from: 'info@thrivehire.co',
                from: 'info@thrivehire.co',
                // email: 'aakash@enginehire.ca',
                email: 'info@thrivehire.org',
                reply: 'info@thrivehire.co',
                // userID: this.aakashid,
                userID: 4, // Hard coding to my production ID for now
              }
            )
            this.$store.dispatch('sendEmail',
              {
                subject: 'New Event Post!',
                message: 'New event posted with the title: '+this.title+'\nPosted By: '+this.user.email,
                // from: 'info@thrivehire.co',
                from: 'info@thrivehire.co',
                email: 'aakash@enginehire.ca',
                reply: 'info@thrivehire.co',
                // userID: this.aakashid,
                userID: 4, // Hard coding to my production ID for now
              }
            )
          })
          .catch(error => console.log(error))
      },
      update() {
        this.test()
        this.prepBeforeSaving()

        axios.patch('/api/events/'.concat(this.listingID.toString()).concat('/'), {
          // poster: this.userID,
          // poster_name: this.user.employer_name,
          title: this.title,
          description: this.description,
          categories: this.focusAreas,
          event_type: this.type,
          fee: this.fee,
          link: this.link,

          date: this.date,
          start_time: this.startTime,
          end_time: this.endTime,
          timezone: this.timezone,

          address1: this.address1,
          address2: this.address2,
          postal_code: this.postalCode,
          city: this.city,
          provincestate: this.provinceState,
          country: this.country,
        })
          .then(res => {
            console.log(res)

            // broadcast to the parent compoenent that a job has been posted
            // this.$emit('jobPosted', true) // Lecture 112
            this.$emit('eventUpdated') // Lecture 112
          })
          .catch(error => console.log(error))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/events/EventForm.vue